import gmailIcon from '@/assets/icons/gmail.svg'
import googleCalendarIcon from '@/assets/icons/g_calendar.png'
import outlookCalendarIcon from '@/assets/icons/outlook_calendar.png'
import yandexMailIcon from '@/assets/icons/yandex-mail.svg'
import yandexCalendarIcon from '@/assets/icons/ya_calendar.png'

type LogoProps = {
  className?: string
}

export function JiraLogo({ className = 'size-7' }: LogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      viewBox="0 0 40.343 42"
      className={className}
    >
      <path
        fill="#2684ff"
        d="M20.172 27.858L13.314 21l6.858-6.858V0L.586 19.586a2 2 0 0 0 0 2.828L20.172 42s3-2 3-7a11.639 11.639 0 0 0-3-7.142Z"
      />
      <path
        fill="#1d78f2"
        d="m14.385 19.667.131.131 5.656-5.656V0L9.571 10.6a20.2 20.2 0 0 0 4.814 9.067Z"
      />
      <path
        fill="#126ae5"
        d="m15.832 18.285.1.1 4.242-4.242V0l-8.866 8.866a18.21 18.21 0 0 0 4.524 9.419Z"
      />
      <path
        fill="#0b60da"
        d="M20.172 14.142V0l-7 7a15.546 15.546 0 0 0 4.171 9.97Z"
      />
      <path
        fill="#0154ce"
        d="M15.172 7c0 4.746 3.407 8.371 3.585 8.556l1.415-1.414V0L15.35 4.822A13.161 13.161 0 0 0 15.172 7Z"
      />
      <path
        fill="#2482fd"
        d="M20.172 14.142 27.029 21l-6.857 6.858V42l19.585-19.586a2 2 0 0 0 0-2.828L20.172 0s-3 2-3 7a11.639 11.639 0 0 0 3 7.142Z"
      />
      <path
        fill="#1d78f2"
        d="m25.958 22.333-.131-.131-5.655 5.656V42l10.6-10.6a20.2 20.2 0 0 0-4.814-9.067Z"
      />
      <path
        fill="#126ae5"
        d="m24.511 23.715-.1-.1-4.241 4.242V42l8.866-8.866a18.216 18.216 0 0 0-4.525-9.419Z"
      />
      <path
        fill="#0b60da"
        d="M20.172 27.858V42l7-7A15.545 15.545 0 0 0 23 25.03Z"
      />
      <path
        fill="#0154ce"
        d="M25.172 35c0-4.746-3.407-8.371-3.586-8.556l-1.414 1.414V42l4.822-4.822A13.27 13.27 0 0 0 25.172 35Z"
      />
      <path
        fill="#2684ff"
        d="M20.172 27.858 13.314 21H2.172v3l18 18s3-2 3-7a11.639 11.639 0 0 0-3-7.142Z"
      />
    </svg>
  )
}

export function ConfluenceLogo({ className = 'size-7' }: LogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      viewBox="0 0 32 32"
      className={className}
    >
      <path
        fill="#2684ff"
        d="M6.9 20.8c-1.1 0-2.1-.4-2.9-1.2-1.6-1.6-1.6-4.2 0-5.8l5.8-5.8c1.6-1.6 4.2-1.6 5.8 0 .7.7 1.1 1.6 1.2 2.5h-3.5c-.1-.1-.1-.2-.2-.3-.3-.3-.8-.3-1.1 0l-5.8 5.8c-.3.3-.3.8 0 1.1.3.3.8.3 1.1 0l1.7-1.7 2.4 2.4-1.7 1.7c-.8.9-1.8 1.3-2.8 1.3Z"
      />
      <path
        fill="#0052cc"
        d="M19.3 24.9c-1.1 0-2.1-.4-2.9-1.2-.7-.7-1.1-1.6-1.2-2.5h3.5c.1.1.1.2.2.3.3.3.8.3 1.1 0l5.8-5.8c.3-.3.3-.8 0-1.1-.3-.3-.8-.3-1.1 0L23 16.3l-2.4-2.4 1.7-1.7c1.6-1.6 4.2-1.6 5.8 0s1.6 4.2 0 5.8l-5.8 5.8c-.8.7-1.9 1.1-3 1.1Z"
      />
      <path fill="#2684ff" d="m10.7 18.2 7.2-7.2 2.4 2.4-7.2 7.2-2.4-2.4Z" />
    </svg>
  )
}

export function GitHubLogo({ className = 'size-7' }: LogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      viewBox="0 0 24 24"
      className={className}
    >
      <path
        fill="#181717"
        d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0 0 24 12c0-6.63-5.37-12-12-12Z"
      />
    </svg>
  )
}

export function GmailLogo({ className = 'size-7' }: LogoProps) {
  return <img src={gmailIcon} alt="" aria-hidden="true" className={className} />
}

export function YandexMailLogo({ className = 'size-7' }: LogoProps) {
  return (
    <img src={yandexMailIcon} alt="" aria-hidden="true" className={className} />
  )
}

export function KaitenLogo({ className = 'size-7' }: LogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      viewBox="0 0 32 32"
      className={className}
    >
      <rect width="32" height="32" rx="8" fill="#00a8a8" />
      <path
        fill="#ffffff"
        d="M9 8h5v7.1L20.4 8H27l-7.6 8.2L27.5 24h-6.9L14 17.5V24H9V8Z"
      />
    </svg>
  )
}

export function WeeekLogo({ className = 'size-7' }: LogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      viewBox="0 0 32 32"
      className={className}
    >
      <rect width="32" height="32" rx="8" fill="#111827" />
      <path
        fill="#8b5cf6"
        d="M6 9h4.4l2.1 12L15 9h3.9l2.6 12L23.6 9H28l-4 14h-5l-2.1-9.4L14.8 23h-5L6 9Z"
      />
      <path fill="#22c55e" d="M21 22.7 27.2 9H29l-6.2 13.7H21Z" />
    </svg>
  )
}

export function YonoteLogo({ className = 'size-7' }: LogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      viewBox="0 0 32 32"
      className={className}
    >
      <rect width="32" height="32" rx="8" fill="#2563eb" />
      <path
        fill="#ffffff"
        d="M7 8h5.2l3.8 6.4L19.8 8H25l-6.6 10.3V24h-4.8v-5.7L7 8Z"
      />
      <circle cx="23.5" cy="21.5" r="2.5" fill="#93c5fd" />
    </svg>
  )
}

export function GoogleCalendarLogo({ className = 'size-7' }: LogoProps) {
  return (
    <img
      src={googleCalendarIcon}
      alt=""
      aria-hidden="true"
      className={`${className} object-contain`}
    />
  )
}

export function YandexCalendarLogo({ className = 'size-7' }: LogoProps) {
  return (
    <img
      src={yandexCalendarIcon}
      alt=""
      aria-hidden="true"
      className={`${className} object-contain`}
    />
  )
}

export function OutlookCalendarLogo({ className = 'size-7' }: LogoProps) {
  return (
    <img
      src={outlookCalendarIcon}
      alt=""
      aria-hidden="true"
      className={`${className} object-contain`}
    />
  )
}

export function KonturLogo({ className = 'size-7' }: LogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      viewBox="0 0 32 32"
      className={className}
    >
      <rect width="32" height="32" rx="8" fill="#2f80ed" />
      <path
        fill="#ffffff"
        d="M8 8h4.8v6.7L18.6 8h6.1l-7 7.8L25 24h-6.3l-5.9-6.6V24H8V8Z"
      />
    </svg>
  )
}

export function TelegramLogo({ className = 'size-7' }: LogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      viewBox="0 0 32 32"
      className={className}
    >
      <circle cx="16" cy="16" r="16" fill="#229ed9" />
      <path
        fill="#ffffff"
        d="M23.7 9.2 20.8 23c-.2 1-1 1.2-1.8.7l-4.9-3.6-2.3 2.2c-.3.3-.5.5-1 .5l.4-5 9.1-8.2c.4-.4-.1-.6-.6-.2l-11.3 7-4.8-1.5c-1-.3-1-1 .2-1.5l18.8-7.2c.9-.3 1.7.2 1.4 1.5Z"
      />
    </svg>
  )
}

export function MoreIntegrationsLogo({ className = 'size-7' }: LogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      viewBox="0 0 32 32"
      className={className}
    >
      <rect width="32" height="32" rx="8" fill="#374151" />
      <circle cx="10" cy="16" r="2.2" fill="#ffffff" />
      <circle cx="16" cy="16" r="2.2" fill="#ffffff" />
      <circle cx="22" cy="16" r="2.2" fill="#ffffff" />
    </svg>
  )
}
